const comPath = 'documents/valuation/communications'
const imgPath = 'valuation/communications'

export default {
  publications: [
    {
      name: 'Antimicrobial Resistance & Infection Control',
      logo: 'valuation/publications/BMC_ARIC_cover.jpg',
      cards: [
        {
          title: '2024',
          items: [
            {
              title: `
Impact of sterile gloving during proximal manipulation of central line catheter hub:
the multicenter observational study CleanHandPROX
`,
              text: 'Octobre 2024',
              link: `documents/valuation/publications/CleanHandPROX.pdf`,
              description: `SPIADI2024 - Article CleanHandPROX.pdf`,
              icon: 'pdf'
            }
          ]
        }
      ]
    },
    {
      name: 'European Journal of Medical Research',
      logo: 'valuation/publications/BMC_EJMR_cover.jpg',
      cards: [
        {
          title: '2023',
          items: [
            {
              title: `
Ultrasound guidance practices used for the placement of vascular
 accesses in intensive care units: an observational multicentre study
`,
              text: 'Novembre 2023',
              link: `documents/valuation/publications/echo.pdf`,
              description: `SPIADI2023 - Article Échoguidage.pdf`,
              icon: 'pdf'
            }
          ]
        }
      ]
    },
    {
      name: 'BMC Medical Education',
      logo: 'valuation/publications/BMC_ME_cover.jpg',
      cards: [
        {
          title: '2023',
          items: [
            {
              title: `
Impact of a training strategy on improving
compliance of hand hygiene and gloving
during the placement of a short peripheral
venous catheter: the multicentre study
CleanHand4`,
              text: 'Octobre 2023',
              link: `documents/valuation/publications/cleanhand4.pdf`,
              description: `SPIADI2023 - Article CleanHand4.pdf`,
              icon: 'pdf'
            }
          ]
        }
      ]
    },
    {
      name: 'Microorganisms',
      logo: 'valuation/publications/microorganisms_cover.jpg',
      cards: [
        {
          title: '2022',
          items: [
            {
              title: `
Strong Biofilm Formation and Low Cloxacillin Susceptibility in
Biofilm-Growing CC398 <i>Staphylococcus aureus</i> Responsible for
Bacteremia in French Intensive Care Units, 2021`,
              text: 'Octobre 2022',
              link: `documents/valuation/publications/reaexplaur.pdf`,
              description: `SPIADI2022 - Article RÉA expl AUR.pdf`,
              icon: 'pdf'
            }
          ]
        }
      ]
    },
    {
      name: 'CMI',
      logo: 'valuation/publications/CMI_cover.jpg',
      cards: [
        {
          title: '2021',
          items: [
            {
              title: `
A prospective multicentre surveillance study to investigate the risk
associated with contaminated sinks in the intensive care unit`,
              text: 'Février 2021',
              link: `documents/valuation/publications/reasink.pdf`,
              description: `SPIADI2020 - Article RÉA Sink.pdf`,
              icon: 'pdf'
            }
          ]
        }
      ]
    },

    {
      name: 'EJCMID',
      logo: 'valuation/publications/EJCMID_cover.jpg',
      cards: [
        {
          title: '2025',
          items: [
            {
              title: `
                Incidence trends and epidemiology of invasive
                device-associated bacteremia in French nursing
                home residents, 2020–2024: Insights from the
                SPIADI Prospective Multicenter Study`,
              text: 'Juin 2025',
              link: `documents/valuation/publications/EHPAD-SPIADI-2020-2024.pdf`,
              description: `SPIADI2025 - Article résultats SPIADI EHPAD 2020-2024.pdf`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2020',
          items: [
            {
              title: `
<i>Staphylococcus capitis</i> isolated from bloodstream infections:
a nationwide 3-month survey in 38 neonatal intensive care units`,
              text: 'Mars 2020',
              link: `documents/2019/SPIADI2019 - Article S. capitis.pdf`,
              description: `SPIADI2019 - Article S. capitis.pdf`,
              icon: 'pdf'
            }
          ]
        }
      ]
    },

    {
      name: 'Annals of Hematology',
      logo: 'valuation/publications/Annals_of_hematology_cover.jpg',
      cards: [
        {
          title: '2025',
          items: [
            {
              title: `Trends in the epidemiology of intravascular device-associated bacteremia among 
French hematology patients: insights from the SPIADI prospective 
multicenter study, 2020–2024`,
              text: 'Janvier 2025',
              link: `documents/valuation/publications/hemato.pdf`,
              icon: 'pdf'
            }
          ]
        }
      ]
    },

    {
      name: 'Frontiers in microbiology',
      logo: 'valuation/publications/Frontiers_in_microbiology_cover.jpg',
      cards: [
        {
          title: '2025',
          items: [
            {
              title: `Infusion line contamination in preterm neonates: impact of
infusion line design, length, and use duration: the multicenter ChronoBIOline study`,
              text: 'Janvier 2025',
              link: `documents/valuation/publications/ChronoBIOline.pdf`,
              icon: 'pdf'
            }
          ]
        }
      ]
    },

    {
      name: 'HYGIENES',
      logo: 'valuation/publications/Hygiènes_cover.jpg',
      cards: [
        {
          title: '2024',
          items: [
            {
              title: `En direct de… la mission nationale Spiadi – Retour sur les cinq années 2019-2023`,
              text: 'Janvier 2024',
              link: `https://www.hygienes.net/actualite/en-direct/en-direct-de-la-mission-nationale-spiadi-retour-sur-les-cinq-annees-2019-2023`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2021',
          items: [
            {
              title: `Facteurs contextuels d'efficacité des dispositifs de prévention des infections associées aux soins : les apports de la recherche`,
              text: 'Avril 2021',
              link: `https://www.hygienes.net/publication-scientifique/facteurs-contextuels-defficacite-des-dispositifs-de-prevention-des-infections-associees-aux-soins-les-apports-de-la-recherche`,
              icon: 'pdf'
            },
            {
              title: `Pneumopathies associées à la ventilation dans les services de réanimation français au premier semestre 2020`,
              text: 'Janvier 2021',
              link: `https://www.hygienes.net/publication-scientifique/pneumopathies-associees-a-la-ventilation-dans-les-services-de-reanimation-francais-au-premier-semestre-2020`,
              icon: 'pdf'
            }
          ]
        }
      ]
    }
  ],
  congresses: [
    {
      name: 'SF2H',
      logo: `${imgPath}/SF2H_logo.jpg`,
      cards: [
        {
          title: '2025',
          items: [
            {
              title: `Étude multicentrique des bactériémies liées aux
                      dispositifs invasifs chez les personnes âgées (2020-2024)`,
              text: 'Communication orale - du 4 au 6 juin 2025',
              link: `${comPath}/SF2H/2025/SPIADI2025 - Etude multicentrique des bactériémies liées aux dispositifs invasifs chez les personnes âgées 2020-2024.pdf`,
              description: `SPIADI2025 - SF2H - Etude multicentrique des bactériémies liées aux dispositifs invasifs chez les personnes âgées 2020-2024.`,
              icon: 'pdf'
            },
            {
              title: `Les bactériémies liées à un cathéter en EHPAD aujourd’hui :
                      retour sur les résultats de la mission nationale SPIADI`,
              text: 'Communication orale - du 4 au 6 juin 2025',
              link: `${comPath}/SF2H/2025/SPIADI2025 - Les bactériémies liées à un cathéter en EHPAD aujourd’hui - résultats SPIADI.pdf`,
              description: `SPIADI2025 - SF2H - Les bactériémies liées à un cathéter en EHPAD aujourd’hui : résultats de la mission nationale SPIADI.`,
              icon: 'pdf'
            },
            {
              title: `Prévention des infections liées à un cathéter en Néonatologie :
                      retour sur les résultats de l’étude ChronoBIOline`,
              text: 'Communication orale - du 4 au 6 juin 2025',
              link: `${comPath}/SF2H/2025/SPIADI2025 - Les infections liées à un cathéter en Néonatologie - résultats ChronoBIOline.pdf`,
              description: `SPIADI2025 - SF2H - Les infections liées à un cathéter en Néonatologie : résultats ChronoBIOline.`,
              icon: 'pdf'
            },
            {
              title: `L’hygiène des mains lors de la pose et des manipulations des cathéters centraux et
                      périphériques : étude observationnelle dans les services de Néonatologie, 2020-2024`,
              text: 'Poster - du 4 au 6 juin 2025',
              link: `${comPath}/SF2H/2025/SPIADI2025 - Etude observationnelle HDM en Neonatologie.pdf`,
              description: `SPIADI2025 - SF2H - L’hygiène des mains lors de la pose et des manipulations des cathéters centraux et périphériques : étude observationnelle dans les services de Néonatologie, 2020-2024`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2024',
          items: [
            {
              title: `L’Étude multicentrique CleanHandPROX : Impact du port des gants stériles lors d’une manipulation
              proximale d’un cathéter central et d’un Midline avec prolongateur intégré`,
              text: 'Communication orale - du 5 au 7 juin 2024',
              link: `${comPath}/SF2H/2024/SPIADI2024 - Etude multicentrique CleanHandPROX.pdf`,
              description: `SPIADI2024 - SF2H - L’Étude multicentrique CleanHandPROX : Impact du port des gants stériles lors d’une manipulation proximale d’un cathéter central et d’un Midline avec prolongateur intégré`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2023',
          items: [
            {
              title: `Dispositifs intravasculaires, ce que nous apprend SPIADI`,
              text: 'Communication orale - du 31 mai au 2 juin 2023',
              link: `https://www.cpias-centre.fr/wp-content/uploads/2023/07/2023-SF2H-DISPOSITIFS-INTRAVASCULAIRES.pdf`,
              description: `SPIADI2023 - SF2H - Dispositifs intravasculaires, ce que nous apprend SPIADI`,
              icon: 'pdf'
            },
            {
              title: `Risque infectieux et échoguidage pour l'insertion des cathéters centraux en réanimation adulte : étude observationnelle multicentrique, 2022`,
              text: 'Communication orale - du 31 mai au 2 juin 2023',
              link: `https://www.cpias-centre.fr/wp-content/uploads/2023/07/2023-SF2H-ECHOGUIDAGE.pdf`,
              description: `SPIADI2023 - SF2H - Risque infectieux et échoguidage pour l'insertion des cathéters centraux en réanimation adulte : étude observationnelle multicentrique, 2022`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2022',
          items: [
            {
              title: `Étude observationnelle prospective multicentrique de la pose et de l'utilisation des PICCLINES`,
              text: 'Communication orale - du 1 au 3 juin 2022',
              link: `${comPath}/SF2H/2022/SPIADI2022 - SF2H - Étude observationnelle prospective multicentrique de la pose et de l'utilisation des PICCLINES.pdf`,
              description: '',
              icon: 'pdf'
            },
            {
              title: `Étude observationnelle multicentrique de l'hygiène des mains pour la pose des cathéters et la manipulation des lignes`,
              text: 'Communication orale - du 1 au 3 juin 2022',
              link: `${comPath}/SF2H/2022/SPIADI2022 - SF2H - Étude observationnelle multicentrique de l'hygiène des mains pour la pose des cathéters et la manipulation des lignes.pdf`,
              description: '',
              icon: 'pdf'
            },
            {
              title: `VALV'FRICTION - un outil pédagogique pour améliorer l'utilisation des valves bidirectionnelles`,
              text: 'Poster - du 1 au 3 juin 2022',
              link: `${comPath}/SF2H/2022/SPIADI2022 - VALV'FRICTION - un outil pédagogique pour améliorer l'utilisation des valves bidirectionnelles.pdf`,
              description: '',
              icon: 'pdf'
            },
            {
              title: `Les bactériémies liées à un PICCline aujourd'hui`,
              text: 'Poster - du 1 au 3 juin 2022',
              link: `${comPath}/SF2H/2022/SPIADI2022 - SF2H - Les bactériémies liées à un PICCline aujourd'hui.pdf`,
              description: '',
              icon: 'pdf'
            },
            {
              title: `Les bactériémies liées à un Midline aujourd'hui en France`,
              text: 'Poster - du 1 au 3 juin 2022',
              link: `${comPath}/SF2H/2022/SPIADI2022 - SF2H - Les bactériémies liées à un Midline aujourd'hui en France.pdf`,
              description: '',
              icon: 'pdf'
            },
            {
              title: `Étude observationnelle multicentrique de l'hygiène des mains dans les services de long séjour et en EHPAD, 2021`,
              text: 'Poster - du 1 au 3 juin 2022',
              link: `${comPath}/SF2H/2022/SPIADI2022 - SF2H - Étude observationnelle multicentrique de l'hygiène des mains dans les services de long séjour et en EHPAD, 2021.pdf`,
              description: '',
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2021',
          items: [
            {
              title: `
<i>Staphylococcus capitis</i> et cathétérisme en réanimation néonatale, aujourd'hui`,
              text: 'Communication orale - du 04/10 au 06/10/2021',
              link: `${comPath}/SF2H/2021/capitis2021.pdf`,
              description: '',
              icon: 'pdf'
            }
          ]
        }
      ]
    },

    {
      name: 'SFAR',
      logo: 'valuation/communications/SFAR_logo.jpg',
      cards: [
        {
          title: '2023',
          items: [
            {
              title: `
Pose des cathéters en REA -
Etude observationnelle multicentrique, 2020-2023
`,
              text: 'Communication orale - du 20/09 au 22/09/2023',
              link: `${comPath}/SFAR/2023/SPIADI2023 - SFAR.pdf`,
              description: `SPIADI2023 - SFAR - Pose des cathéters en REA - Etude observationnelle multicentrique 2020-2023.pdf`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2021',
          items: [
            {
              title: `
Pandémie COVID19 et survenue des bactériémies et des PAVM,
étude d'une cohorte de 102 services de réanimation (2019, 2020, 2021)
`,
              text: 'Poster commenté - du 23/09 au 25/09/2021',
              link: `${comPath}/SFAR/2021/SPIADI2021 - Poster.pdf`,
              description: 'SPIADI2021 - SFAR - Poster.pdf',
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2020',
          items: [
            {
              title: `
Entérobactéries et <i>Pseudomonas aeruginosa</i> multirésistants à
proximité des patients,
résultats de l'étude multicentrique nationale RÉA Sink 2020
`,
              text: 'Communication orale - 24/09/2020',
              link: `${comPath}/SFAR/2020/SPIADI2020 - Réa sink.pdf`,
              description: 'SPIADI2020 - Résultats RÉA Sink.pdf',
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2019',
          items: [
            {
              title: `
Surveillance des infections associées aux dispositifs invasifs, 
enquête nationale 2019,
premiers résultats pour les services de Réanimation`,
              text: 'Communication orale - 19/09/2019',
              link: `${comPath}/SFAR/2019/SPIADI2019 - Réa Inf ADI.pdf`,
              description: 'SPIADI2019 - Résultats Réa Inf ADI.pdf',
              icon: 'pdf'
            }
          ]
        }
      ]
    },
    {
      name: 'SRLF',
      logo: 'valuation/communications/SRLF_logo.jpg',
      cards: [
        {
          title: '2024',
          items: [
            {
              title: `
Étude prospective multicentrique des pratiques de réfection de pansements de
cathéters en réanimation adulte
`,
              text: 'Communication orale - 12 au 14 juin 2024',
              link: `${comPath}/SRLF/2024/SPIADI2024 - Présentation SRLF.pdf`,
              description: 'SPIADI2024 - Présentation SRLF.pdf',
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2023',
          items: [
            {
              title: `
FC-218 - Ultrasound guidance practices used for the placement of central venous
catheters in intensive care units an observational multicentre study`,
              text: 'Communication orale - 14-16 juin 2023',
              link: `${comPath}/SRLF/2023/SPIADI2023 - Présentation SRLF.pdf`,
              description: 'SPIADI2023 - Présentation SRLF.pdf',
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2021',
          items: [
            {
              title: `
Étude prospective multicentrique des pratiques d’insertion et d’utilisation des
cathéters centraux en Réanimation, 2020`,
              text: 'Communication orale - 9 juin 2021',
              link: `${comPath}/SRLF/2021/SPIADI2021 - Présentation SRLF.pdf`,
              description: 'SPIADI2021 - Présentation SRLF.pdf',
              icon: 'pdf'
            }
          ]
        }
      ]
    },
    {
      name: 'SFAV',
      logo: 'valuation/communications/SFAV_logo.jpeg',
      cards: [
        {
          title: '2023',
          items: [
            {
              title: `Les enseignements de la surveillance des bactériémies liées à un cathéter de dialyse et des observations de pratiques dans les services de néphrologie et d’hémodialyse`,
              text: 'Communication orale - du 01 au 03 juin 2023',
              link: `${comPath}/SFAV/2023/SPIADI2023 - SFAV.pdf`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2022',
          items: [
            {
              title: `Surveillance prospective et Prévention des infections liées à un site d’accès vasculaire pour la dialyse, données nationales 2019-2021`,
              text: 'Communication orale - du 12 au 14 mai 2022',
              link: `${comPath}/SFAV/2022/SPIADI2022 - SFAV - Surveillance prospective et Prévention des infections liées à un site d’accès vasculaire pour la dialyse, données nationales 2019-2021.pdf`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2019',
          items: [
            {
              title: 'La mission nationale SPIADI et le patient dialysé',
              text: 'Communication orale - 16/05/2019',
              link: `${comPath}/SFAV/2019/SPIADI2019 - Présentation SFAV.pdf`,
              description: 'SPIADI2019 - Présentation SFAV.pdf',
              icon: 'pdf'
            }
          ]
        }
      ]
    },
    {
      name: 'GIFAV',
      logo: `${imgPath}/GIFAV_logo.jpg`,
      cards: [
        {
          title: '2019',
          items: [
            {
              title: 'La mission nationale SPIADI',
              text: `Poster - 31/01/2019<br />
<div>
  <h5>
    <span class="text-warning text-center">
      <strong>Prix du meilleur poster</strong>
      <span class="glyphicon glyphicon-thumbs-up" style="margin-left: 0.4rem">
      </span>
    </span>
  </h5>
</div>`,
              link: `${comPath}/GIFAV/2019/SPIADI2019 - Poster GIFAV.pdf`,
              description: 'SPIADI2019 - Poster GIFAV.pdf',
              icon: 'pdf'
            }
          ]
        }
      ]
    },
    {
      name: 'RICAI',
      logo: 'valuation/communications/RICAI_logo.png',
      cards: [
        {
          title: '2021',
          items: [
            {
              title: 'Epidémiologie microbienne des infections associées aux cathéters et pandémie COVID-19<br>(données nationales, cohorte 2019-2021)',
              text: 'Communication orale - du 13 au 14/12/2021',
              link: `${comPath}/RICAI/2021/ricai_spiadi_2021.pdf`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2020',
          items: [
            {
              title: 'Résultats de l’enquête RÉA Sink',
              text: 'Diaporama commenté - 14/12/2020',
              link: 'https://youtu.be/mXntC239xT4',
              icon: 'youtube'
            },
            {
              title: 'Résultats de la surveillance SPIADI en réanimation néonatale',
              text: 'Diaporama commenté - 14/12/2020',
              link: 'https://youtu.be/0XDCnp_hhl8',
              icon: 'youtube'
            },
            {
              title: `Étude des caractéristiques des patients bactériémiques en
                fonction du statut COVID-19`,
              text: 'Diaporama commenté - 14/12/2020',
              link: 'https://youtu.be/2MXuQOQdbu4',
              icon: 'youtube'
            }
          ]
        },
        {
          title: '2019',
          items: [
            {
              title: `
BMR, BHRe et <i>Candida</i> flu-R responsables de bactériémies associées aux
cathéters,
résultats de la surveillance nationale SPIADI, 2019`,
              text: 'Poster - 16/12/2019',
              link: `${comPath}/RICAI/2019/SPIADI2019 - Présentation RICAI.pdf`,
              description: 'SPIADI2019 - Présentation RICAI.pdf',
              icon: 'pdf'
            }
          ]
        }
      ]
    },

    {
      name: 'ECCMID',
      logo: `${imgPath}/ECCMID_logo.jpg`,
      cards: [
        {
          title: '2024',
          items: [
            {
              title: `Impact of sterile gloving during proximal manipulation of a central venous catheter : the multicentre study CleanHandPROX`,
              text: 'Poster - du 27 au 30/04/2024',
              link: `${comPath}/ECCMID/2024/SPIADI2024 - Impact of sterile gloving during proximal manipulation of a central venous catheter-the multicentre study CleanHandPROX.pdf`,
              description: `SPIADI2024 - Impact of sterile gloving during proximal manipulation of a central venous catheter : the multicentre study CleanHandPROX`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2023',
          items: [
            {
              title: `A multicenter observational study of the use of
ultrasound guidance during central catheter insertion`,
              text: 'Poster - du 15 au 18/04/2023',
              link: `${comPath}/ECCMID/2023/SPIADI2023 - A multicenter observational study of the use of ultrasound guidance during central catheter insertion.pdf`,
              description: `SPIADI2023 - A multicenter observational study of the use of ultrasound guidance during central catheter insertion`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2022',
          items: [
            {
              title: `A prospective multicenter observational study of
insertion and use of central lines in the intensive care unit`,
              text: 'e-poster - du 23 au 26/04/2022',
              link: `${comPath}/ECCMID/2022/SPIADI2022 - A prospective multicenter observational study of insertion and use of central lines in the intensive care unit.pdf`,
              description: `SPIADI2022 - A prospective multicenter observational study of insertion and use of central lines in the intensive care unit.pdf`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2020',
          items: [
            {
              title: `Nation-wide survey of catheter-related
               bloodstream infections in medical, surgical and intensive care
               settings, 2019`,
              text: 'Abstract - 18/04/2020',
              link: `${comPath}/ECCMID/2020/SPIADI2020 - Abstract - Nation-wide survey of catheter-related bloodstream infections in medical, surgical and intensive care settings.pdf`,
              description: `SPIADI2020 - Abstract - Nation-wide survey of
catheter-related bloodstream infections in medical, surgical and intensive care
settings.pdf`,
              icon: 'pdf'
            },
            {
              title: `Short-term peripheral venous catheter-related bloodstream
               infections in French healthcare settings, 2019`,
              text: 'Abstract - 18/04/2020',
              link: `${comPath}/ECCMID/2020/SPIADI2020 - Abstract - Short-term peripheral venous catheter-related bloodstream infections in French healthcare settings.pdf`,
              description: `SPIADI2020 - Abstract - Short-term peripheral
venous catheter-related bloodstream infections in French healthcare
settings.pdf`,
              icon: 'pdf'
            }
          ]
        },
        {
          title: '2019',
          items: [
            {
              title: `Implantable port-related bloodstream infections :
                major findings from a multi-centre survey, 2007 - 2018`,
              text: 'Poster - 13/04/2019',
              link: `${comPath}/ECCMID/2019/SPIADI2019 - Poster ECCMID.pdf`,
              description: `SPIADI2019 - Poster - Implantable port-related
bloodstream infections - major findings from a multi-centre survey.pdf`,
              icon: 'pdf'
            },
            {
              title: `Implantable port-related bloodstream infections :
                major findings from a multi-centre survey, 2007 - 2018`,
              text: 'Abstract - 13/04/2019',
              link: `${comPath}/ECCMID/2019/SPIADI2019 - Abstract ECCMID.pdf`,
              description: `SPIADI2019 - Abstract - Implantable port-related
bloodstream infections - major findings from a multi-centre survey.pdf`,
              icon: 'pdf'
            }
          ]
        }
      ]
    },
    {
      name: 'AUTRES',
      logo: `${imgPath}/REPIA_logo.png`,
      cards: [
        {
          title: '2019',
          items: [
            {
              title: `Surveillance des bactériémies liées aux cathéters hors
réanimation : pourquoi ? Comment ?`,
              text: `<strong>42èmes journées d'hygiène hospitalière de Strasbourg</strong><br>Communication orale - 12/12/2019`,
              link: `${comPath}/AUTRES/2019/SPIADI2019 - Présentation JHH.pdf`,
              description: 'SPIADI2019 - Présentation JHH.pdf',
              icon: 'pdf'
            },
            {
              title: `La mission nationale SPIADI`,
              text: `<strong>Salon infirmier - Paris Healthcare week</strong><br>Communication orale - 23/05/2019`,
              link: `${comPath}/AUTRES/2019/SPIADI2019 - Présentation PHW.pdf`,
              description: 'SPIADI2019 - Présentation PHW.pdf',
              icon: 'pdf'
            }

          ]
        }
      ]
    }
  ]
}
